import { render, staticRenderFns } from "./TooltipBlitzschutzkonzept.vue?vue&type=template&id=4857707a&scoped=true&"
import script from "./TooltipBlitzschutzkonzept.vue?vue&type=script&lang=js&"
export * from "./TooltipBlitzschutzkonzept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4857707a",
  null
  
)

export default component.exports